import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  backdrop: {
    backgroundColor: '#01040B5C',
  },
  grip: {
    backgroundColor: '#DDE1E6',
    width: 42,
    height: 4,
    borderRadius: 4,
    margin: '0 auto 12px',
  },
  box: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'white',
    outline: 0,
    padding: '12px 16px 40px 16px',
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    [theme.breakpoints.up(1024)]: {
      padding: '12px 212px 40px 212px',
    },
    [theme.breakpoints.up(1279)]: {
      bottom: 'auto',
      right: 'auto',
      top: '50%',
      left: '50%',
      translate: '-50% -50%',
      width: 427,
      borderRadius: 8,
      boxShadow: '0 0 96px #09173929, 0 0 2px #0917391F',
      padding: 32,
      paddingTop: 36,
    },
  },
  title: {
    '&&': {
      marginBottom: 16,
      color: '#18191E',
      [theme.breakpoints.up(1279)]: {
        color: '#091739',
      },
    },
  },
  text: {
    '&&': {
      marginBottom: 24,
      color: '#091739',
      [theme.breakpoints.up(1279)]: {
        color: '#091739',
      },
    },
  },
  buttons: {
    display: 'flex',
    gap: 8,
    [theme.breakpoints.up(1279)]: {
      gap: 16,
      flexDirection: 'row-reverse',
      justifyContent: 'flex-end',
    },
  },
  button: {
    [theme.breakpoints.up(1279)]: {
      width: 'max-content',
    },
  },
}));
